export const ProductDataModel = {
    sku: "",
    name: "",
    description: "",
    returnPolicy: "",
    comment: "",
    manufacturingName:"",
    manufacturingDetail:"",
    manufacturingContact:"",
    barcode: "",
    status: "",
    images: null,
    categories: null,
    active: true,
    productSizes: [
        {
            length: 0,
            width: 0,
            height: 0,
            weight: 0,
            newUnit: "Grams",
            unitValue: 0,
            quantity: "",
            price: 0,
            crossPrice: 0,
            packagingCharge: 0,
            shippingCategory: "OTHER"
        }
    ],
    tags: "",
    label: "",
    price: 0,
    taxable: 0,
    taxPercentage: 0,
    discount: 0,
    crossPrice: 0,
    tax: undefined,
    included: true,
    imageDisplayMode: "fit"

}